import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="w-full bg-blue-950 text-white flex justify-between items-center p-6 border-b border-gray-300 relative z-50">
      {/* Logo */}
      <h1 className="text-3xl md:text-4xl font-semibold font-serif transition duration-500 hover:text-gray-300">
        <Link to="/">Quraniverse</Link>
      </h1>

      {/* Desktop Menu */}
      <div className="hidden md:flex space-x-6 items-center">
        <Link to="/" className="text-xl transition duration-300 hover:text-gray-300">
          Home
        </Link>
        <Link to="/about" className="text-xl transition duration-300 hover:text-gray-300">
          About
        </Link>
        <Link to="/contact" className="text-xl transition duration-300 hover:text-gray-300">
          Contact
        </Link>
     
      </div>

      {/* Mobile Menu Button */}
      <button
        className="md:hidden text-3xl transition duration-300 hover:text-gray-300 z-50 relative"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Full-Screen Mobile Menu */}
      {menuOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-blue-700 text-white flex flex-col items-center justify-center space-y-8 py-10 z-50">
          <Link 
            to="/" 
            className="text-2xl font-semibold transition duration-300 hover:text-gray-300"
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className="text-2xl font-semibold transition duration-300 hover:text-gray-300"
            onClick={() => setMenuOpen(false)}
          >
            About
          </Link>
          <Link 
            to="/contact" 
            className="text-2xl font-semibold transition duration-300 hover:text-gray-300"
            onClick={() => setMenuOpen(false)}
          >
            Contact
          </Link>
      
        </div>
      )}
    </nav>
  );
};

export default Navbar;
